// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"0ec41854","333":"75135130","488":"54a96bbd","750":"881df6fc","952":"2d7ff8ef"}[chunkId] + ".css";
};